module.exports = __webpack_public_path__ + "static/media/team-4.ee707ef2.jpg";